import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialUpdate from "../social_update";
import UserStatusHeader from "../user_status/user_status_header";
import Spoiler from "../../user_content/spoiler";
import ExpandableHtml from "../../user_content/expandable_html";
import { isEmpty } from "lodash";

export default GrComponentFactory.createClass({
  displayName: "ReadingNoteNewsfeedItem",
  propTypes: {
    readingNotesLinkUrl: React.PropTypes.string.isRequired,
    resourceDisplayName: React.PropTypes.string.isRequired,
    resourceUrl: React.PropTypes.string.isRequired,
    resource: React.PropTypes.shape({
      book: GrPropTypes.book().isRequired,
      headerText: React.PropTypes.string.isRequired,
      highlightText: React.PropTypes.shape(GrPropTypes.expandableHtml()),
      noteText: React.PropTypes.shape(GrPropTypes.expandableHtml()),
      isSpoiler: React.PropTypes.bool.isRequired,
      user: GrPropTypes.user().isRequired,
    }).isRequired,
    user: GrPropTypes.user(),
  },

  renderSpoilerWarning() {
    return (
      <span className="newsfeedNoteHighlightTextContainer__spoilerWarning">
        {`This ${this.props.resource.headerText} contains spoilers…`}
      </span>
    );
  },

  renderHeader() {
    return <UserStatusHeader headerText={`shared a ${this.props.resource.headerText} from `}
                             book={this.props.resource.book}/>;
  },

  renderBody() {
    const body = (
      <div className="newsfeedNoteHighlightTextContainer newsfeedNoteHighlightTextContainer--withBorder">
        {!isEmpty(this.props.resource.highlightText) &&
          <div className="newsfeedNoteHighlightTextContainer__highlightText newsfeedNoteHighlightTextContainer__highlightText--withMargin">
            <ExpandableHtml {...this.props.resource.highlightText}/>
          </div>
        }
        {!isEmpty(this.props.resource.noteText) && this.renderNoteText()}
        {this.renderReadingNotesLink()}
      </div>
    );

    if (this.props.resource.isSpoiler) {
      return (
        <Spoiler spoilerWarning={this.renderSpoilerWarning()}>
          {body}
        </Spoiler>
      );
    } else {
      return body;
    }
  },

  renderNoteText() {
    return <div className="newsfeedNoteHighlightTextContainer__noteContainer newsfeedNoteHighlightTextContainer__noteContainer--withMargin">
      <div className="newsfeedNoteHighlightTextContainer__noteImage">
        <div className="gr-icon gr-icon--readingNotesIcon">
          <span className="u-visuallyHidden">Note</span>
        </div>
      </div>
      <div className="newsfeedNoteHighlightTextContainer__noteText">
        <ExpandableHtml {...this.props.resource.noteText}/>
      </div>
    </div>;
  },

  renderReadingNotesLink() {
    const linkText = `See all of ${this.props.resource.user.viewableName}’s notes & highlights`;

    return <div className="newsfeedNoteHighlightTextContainer__noteLink">
      <a href={this.props.readingNotesLinkUrl}>
        {linkText}
      </a>
    </div>;
  },

  render() {
    return <SocialUpdate
      {...this.props}
      header={this.renderHeader()}
      body={this.renderBody()}
    />;
  },
});
